// Impact-based tiers (mirror of backend risk_engine.py) — no weights or scores.
// critical: flooded now · high: floods in the real 72 h forecast · medium: flooded in a recorded storm replay.
export function scoreAssets(raw, inundation, waterLevel) {
  const now = new Set(inundation?.flagged_ids || []);
  const high = new Set(inundation?.exposure?.high || []);
  const med = new Set(inundation?.exposure?.medium || []);
  return raw.map((a) => {
    const tier = now.has(a.id) ? "critical" : high.has(a.id) ? "high" : med.has(a.id) ? "medium" : "low";
    const freeboard = a.elevation_m == null ? null : Math.round((a.elevation_m - waterLevel) * 100) / 100;
    return { ...a, tier, freeboard_m: freeboard };
  });
}
